import React, { useState, useEffect } from 'react'
import { Sidebar } from '../../components/Sidebar/Sidebar'
import axios from 'axios'
import { Baseurl } from '../../../Config/Baseurl'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { Link } from 'react-router-dom'

export const ExamStatus = () => {
  toast.configure()
  const [getExams, setgetExams] = useState()

  // set input values
  const [values, setValues] = useState({
    selectedExam: '',
    status: '',
  })

  // input onchange
  let name, value
  const handleChange = (e) => {
    name = e.target.name
    value = e.target.value

    setValues({ ...values, [name]: value })
  }

  useEffect(() => {
    geExams()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // get declared exams
  const geExams = async () => {
    await axios
      .get(Baseurl.nodeLocal + 'exam/fetchAllExams')
      .then((res) => {
        setgetExams(res.data.data)
      })
      .catch((error) => {})
  }

  // update status of selected exam : start / stop
  const updateStatus = async () => {
    await axios
      .post(Baseurl.nodeLocal + 'exam/startStop', {
        exam_id: values.selectedExam,
        start_stop_flag: values.status,
      })
      .then((response) => {
        toast.success(response.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        })
        setTimeout(() => {
          window.location.reload(false)
        }, 2000)
      })
      .catch((error) => {
        toast.error(error.response.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        })
      })
  }
  return (
    <div className="row">
      <div className="col-md-2">
        <Sidebar />
      </div>
      <div className="col-md-10 mt-4 p-2 d-flex justify-content-center align-items-center flex-column mt-5">
        {/* breadcrumbs */}
        <div className="d-flex justify-contetn-center">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/examdashboard" className="link text-primary">
                  Home
                </Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Exam Status
              </li>
            </ol>
          </nav>
        </div>
        <div className="card  overflow-hidden" style={{ width: '25rem' }}>
          <div
            className="p-2"
            style={{ backgroundColor: '#0d6efd', height: '50px' }}
          >
            <h5 style={{ color: 'white' }} className="mx-2 mt-1">
              Exam Status
            </h5>
          </div>

          <div className="row p-3">
            <div className="p-2 mt-3 row">
              <label
                htmlFor="exampleFormControlInput1"
                className="col-md-4 form-label d-flex align-items-center mt-2"
              >
                <h6>Select Exam</h6>
              </label>
              <select
                className="col-md form-select"
                aria-label="Default select example"
                name="selectedExam"
                onChange={handleChange}
                value={values.selectedExam}
              >
                <option value="" selected disabled>
                  Select
                </option>
                {getExams?.map((i, index) => {
                  return (
                    <option value={i.exam_id} key={index}>
                      {i.exam_name}
                    </option>
                  )
                })}
              </select>
            </div>

            <div className="row mt-3">
              <label
                htmlFor="exampleFormControlInput1"
                className="col-md-4 form-label d-flex align-items-center mt-2"
              >
                <h6>Exam Status</h6>
              </label>
              <select
                className="col-md form-select"
                aria-label="Default select example"
                name="status"
                onChange={handleChange}
                value={values.status}
              >
                <option value="" selected disabled>
                  Select
                </option>
                <option value={true}>Start</option>
                <option value={false}>Stop</option>
              </select>
            </div>
          </div>
          <div className="p-3">
            <button
              className="btn btn-primary mt-3"
              type="submit"
              onClick={updateStatus}
            >
              Submit
            </button>
          </div>
        </div>
      </div>{' '}
    </div>
  )
}
